import styled from "styled-components";
import Image from "next/image";
import {
  colors,
  spacing,
  radius,
  textStyles,
  toCSS
} from "design-system/foundation";
import { breakpoints } from "styles";

export const LoadingCard = styled.div`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  width: 100%;
  min-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${spacing["2xl"]};
  align-items: center;
  gap: ${spacing["5xl"]};

  @media ${breakpoints.tablet} {
    width: 480px;
    min-height: auto;
    align-self: center;
    border-radius: ${radius.xl};
    padding: ${spacing["5xl"]};
    background-color: ${colors.bg.base.default};
    box-shadow: 0 8px 32px rgba(24, 27, 37, 0.15);
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${spacing["2xl"]};
`;

export const ContentImage = styled(Image)`
  width: 256px;
  height: 256px;
`;

export const ContentTitle = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.heading.h5)};
  color: ${colors.text.base.primary};
  text-align: center;
`;

export const Banner = styled.div`
  display: flex;
  flex-direction: row;
  width: 312px;
  max-width: 100%;
  border-radius: ${radius.xs};
  padding: ${spacing.xl};
  gap: ${spacing.xl};
  background-color: ${colors.bg.brand.secondarySoft};

  .icon {
    font-size: 24px;
    color: ${colors.icon.state.brandDefault};
  }
`;

export const BannerText = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.body.body5Bold)};
  color: ${colors.text.semantic.brand};
`;

export const BottomContainer = styled.div`
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.xl};
  width: 100%;
  padding: ${spacing["2xl"]};
  background-color: ${colors.bg.base.default};

  @media ${breakpoints.tablet} {
    position: static;
    padding: ${spacing.none};
  }
`;

export const LoadingText = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.body.body4Bold)};
  color: ${colors.text.base.primary};
  text-align: center;
`;

export const LoadingBar = styled.div`
  width: 100%;
  height: 24px;

  > div {
    width: 100%;
    height: 100%;
  }
`;
